/**
 * Feature flags by section (owner, 2026-10-07). Kept apart from the screen so
 * the grouping is tested without rendering it.
 */
import { t } from '../../messages.ts';

export const ALL = '__all';
const OTHER = '__other';

export type FlagRow = {
  code: string;
  label: string;
  description: string;
  surface: string;
  global_enabled: boolean;
  overrides: readonly unknown[];
};

/** Flags grouped by the screen they govern, in the order the server sends; unplaced ones last. */
export function flagSections<F extends FlagRow>(flags: readonly F[]): { id: string; label: string; flags: F[] }[] {
  const out: { id: string; label: string; flags: F[] }[] = [];
  for (const f of flags) {
    const id = f.surface || OTHER;
    let g = out.find((x) => x.id === id);
    if (!g) {
      g = { id, label: f.surface || t('plat.flags.otherSection'), flags: [] };
      out.push(g);
    }
    g.flags.push(f);
  }
  return out.sort((a, b) => (a.id === OTHER ? 1 : 0) - (b.id === OTHER ? 1 : 0));
}
